// Route prefix -> theme class. Order matters (most-specific first).
export const THEME_RULES = [
  { prefix: "/admin", theme: "theme-admin" },
  { prefix: "/castlewood", theme: "theme-castlewood" },
  { prefix: "/vela", theme: "theme-vela" },
  { prefix: "/brionj", theme: "theme-brionj" },
  { prefix: "/", theme: "theme-gmh" },
];

export function resolveTheme(pathname) {
  for (const rule of THEME_RULES) {
    if (rule.prefix === "/") return rule.theme;
    if (pathname === rule.prefix || pathname.startsWith(rule.prefix + "/")) return rule.theme;
  }
  return "theme-gmh";
}

export const ALL_THEME_CLASSES = [
  "theme-gmh",
  "theme-castlewood",
  "theme-vela",
  "theme-brionj",
  "theme-admin",
];

export const BRAND_INFO = {
  gmh: {
    slug: "gmh",
    name: "GMH",
    fullName: "Grand Metropolitan Hotels",
    label: "GMH GROUP",
    home: "/",
    accent: "#1E3A5F",
    voice: "institutional",
  },
  castlewood: {
    slug: "castlewood",
    name: "Castlewood",
    fullName: "Castlewood Hotels & Resorts",
    label: "CASTLEWOOD",
    home: "/castlewood",
    accent: "#5C2730",
    voice: "heritage",
  },
  vela: {
    slug: "vela",
    name: "vela",
    fullName: "Vela Hotels",
    label: "VELA",
    home: "/vela",
    accent: "#E07856",
    voice: "coastal",
  },
  brionj: {
    slug: "brionj",
    name: "Brionj",
    fullName: "Brionj Luxury Hotel Collection",
    label: "BRIONJ",
    home: "/brionj",
    accent: "#C5B188",
    voice: "dark-luxury",
  },
};
